import { CommonApi } from "../../common/api/CommonApi";
import { ApiCarrier } from "../api/ApiCarrier";

export const addCarrier = async (addData) => {
  try {
    const data = await CommonApi().addUser(
      {
        ...addData,
        roleType: "Carrier"
      }
    );

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const getCarriers = async () => {
  try {
    const data  = await ApiCarrier().getCarrier();

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const getCarrierOptions = async () => {
  try {
    const data  = await ApiCarrier().getCarrierOptions();

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};